import { useContext, useLayoutEffect, useState } from 'react';

import { BacktestingContext } from '../../providers/backtesting/backtesting-provider';
import { BacktestLoading } from './components/backtest-loading';
import { BacktestResult } from './components/backtest-result';
import { BacktestResultHeader } from './components/backtest-result-header';
import { BacktestSidebar } from './components/backtest-sidebar';

import './styles.scss';

const Backtesting = () => {
  const { getActiveBacktest } = useContext(BacktestingContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const activeBacktest = getActiveBacktest();
  const isLoading = activeBacktest?.execution.status === 'loading';
  // Whether the backtest has results — drives the top result header. Global
  // config (token/period/frequency) now lives in the Specification tab, so an
  // un-run backtest has no top header at all.
  const hasRun =
    !!activeBacktest?.execution.strategyData &&
    (activeBacktest?.execution.strategyNames.length ?? 0) > 0;
  const activeResultTab = activeBacktest?.execution.activeResultTab ?? 'specification';
  const scrollResetKey = !activeBacktest
    ? 'no-backtest'
    : isLoading
      ? `${activeBacktest.id}:loading`
      : `${activeBacktest.id}:tab:${activeResultTab}`;

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [scrollResetKey]);

  useLayoutEffect(() => {
    document.body.style.overflowY = isLoading ? 'hidden' : '';
    return () => {
      document.body.style.overflowY = '';
    };
  }, [isLoading]);

  const sidebarStateClass = isSidebarOpen
    ? 'backtesting-sidebar-open'
    : 'backtesting-sidebar-close';
  const topHeaderClass = hasRun ? 'backtesting-has-top-header' : 'backtesting-no-top-header';

  return (
    <div className={`backtesting-container ${sidebarStateClass} ${topHeaderClass}`}>
      <BacktestSidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
      {hasRun && (
        <div className="backtesting-header-container">
          <BacktestResultHeader isLoading={isLoading} />
        </div>
      )}
      <div
        className={`backtesting-content-container ${isLoading ? 'backtesting-content-container-loading' : ''}`}
      >
        {isLoading ? <BacktestLoading /> : <BacktestResult />}
      </div>
    </div>
  );
};

export default Backtesting;
